import { format, parseISO, addDays } from 'date-fns'
import useCurrentData from '@/views/composable/useCurrentData'

/**
 * 深夜跨ぎ店舗のクロージング画面で、日付を営業日に合わせて自動調整するcomposable
 * @param {Ref<string>} date - クロージング日（YYYY-MM-DD形式）
 */
export default date => {
  const { currentClub } = useCurrentData()

  const isCrossingMidnight = () => {
    const openAt = currentClub.value?.openAt
    const closeAt = currentClub.value?.closeAt
    if (!openAt || !closeAt) return false

    const openTime = parseISO(openAt)
    const closeTime = parseISO(closeAt)
    const openTimeStr = format(openTime, 'HH:mm')
    const closeTimeStr = format(closeTime, 'HH:mm')

    return openTimeStr > closeTimeStr
  }

  /**
   * 深夜跨ぎ店舗で、入力時刻をクロージング日の営業日範囲に調整する
   * - openAt以降の時刻 → クロージング日当日
   * - openAtより前の時刻（早朝）→ クロージング日の翌日
   */
  const adjustDateForMidnightCrossing = datetime => {
    if (!datetime || !date.value || !isCrossingMidnight()) return datetime

    const openTime = parseISO(currentClub.value.openAt)
    const openTimeStr = format(openTime, 'HH:mm')

    const inputDate = new Date(datetime)
    const inputTimeStr = format(inputDate, 'HH:mm')

    const closingDate = parseISO(date.value)

    if (inputTimeStr < openTimeStr) {
      const nextDay = addDays(closingDate, 1)
      nextDay.setHours(inputDate.getHours(), inputDate.getMinutes(), 0, 0)

      return format(nextDay, "yyyy-MM-dd'T'HH:mm")
    }

    const adjusted = new Date(closingDate)
    adjusted.setHours(inputDate.getHours(), inputDate.getMinutes(), 0, 0)

    return format(adjusted, "yyyy-MM-dd'T'HH:mm")
  }

  /**
   * datetime-localフィールドのデフォルト値を営業日に合わせて生成する
   * - leaveAt: startAtの日付ベース。startAtより前になる場合は翌日に調整
   * - startAt等: クロージング日ベース + 深夜跨ぎ調整
   */
  const buildDefaultDateTime = (key, startAt = null) => {
    const now = new Date()

    if (key === 'leaveAt' && startAt) {
      const startDate = new Date(startAt)
      startDate.setHours(now.getHours(), now.getMinutes(), 0, 0)

      if (startDate < new Date(startAt)) {
        return format(addDays(startDate, 1), "yyyy-MM-dd'T'HH:mm")
      }

      return format(startDate, "yyyy-MM-dd'T'HH:mm")
    }

    if (date.value) {
      const closingDate = parseISO(date.value)
      closingDate.setHours(now.getHours(), now.getMinutes(), 0, 0)

      return adjustDateForMidnightCrossing(format(closingDate, "yyyy-MM-dd'T'HH:mm"))
    }

    return format(now, "yyyy-MM-dd'T'HH:mm")
  }

  return {
    currentClub,
    adjustDateForMidnightCrossing,
    buildDefaultDateTime,
  }
}
